import { getCookie, setCookie } from '../cookie/cookieHandlers'
import { currentLang, LANGUAGES } from './currentLang'
import { currencyStore } from './currency'
import { PRICE_REG_EXP, PRICES_TO_BE_CONVERTED } from '../constants'
import { fetchUrl } from '../utils'

const onBlogPage = location.pathname.includes('/blog')

localStorage.setItem('lang', currentLang)
setCookie('lang', currentLang, 30)

const currentPage = location.pathname
  .replace(`/${currentLang}/`, '')
  .replace('/rus/', '')
  .replace(/^\//, '')

let availablelangs = LANGUAGES.filter(lang => currentLang !== lang?.value)

const langParent = document.querySelector('[data-current-lang-parent]')
const currencyParent = document.querySelector('[data-current-currency-parent]')

const langDropdownWrapper = document.querySelector('[data-lang-dropdown]')
const langDropdownList = document.querySelector('[data-lang-dropdown-list]')
const langsListEl = document.querySelector('[data-langs-list]')

const currencyDropdownWrapper = document.querySelector('[data-currency-dropdown]')
const currencyDropdownList = document.querySelector('[data-currency-dropdown-list]')
const currencyListEl = document.querySelector('[data-currency-list]')

const breakpoint = window.matchMedia('(max-width:1130px)')

function initEventListeners() {
  langParent.removeEventListener('mouseenter', openLangDropdown)
  langParent.removeEventListener('mouseleave', closeLangDropdown)
  langParent?.removeEventListener('click', handleLangClick)
  currencyParent?.removeEventListener('click', handleCurrencyClick)
  currencyParent?.removeEventListener('mouseenter', openCurrencyDropdown)
  currencyParent?.removeEventListener('mouseleave', closeCurrencyDropdown)

  if (breakpoint.matches) {
    langParent?.addEventListener('click', handleLangClick)
    currencyParent?.addEventListener('click', handleCurrencyClick)
  } else {
    langParent.addEventListener('mouseenter', openLangDropdown)
    langParent.addEventListener('mouseleave', closeLangDropdown)
    currencyParent.addEventListener('mouseenter', openCurrencyDropdown)
    currencyParent.addEventListener('mouseleave', closeCurrencyDropdown)
  }
}

initEventListeners()

breakpoint.addEventListener('change', initEventListeners)

document.addEventListener('click', handleDropdownClosing)

if (onBlogPage) {
  const alternateLinks = document.querySelectorAll('link[rel=alternate]')
  const alternateLangs = [...alternateLinks]
    .map(el => el.hreflang.toLowerCase())
    .filter(el => el !== 'x-default')
    .join(';')

  availablelangs = availablelangs.filter(
    lang =>
      alternateLangs.includes(lang.value) ||
      (lang.value === 'rus' && alternateLangs.includes('ru')) ||
      lang.value === 'aa',
  )
}

renderLangsListMarkup()
initLanguageButtons()

convertPrices()
currencyStore.subscribe(() => {
  convertPrices()
})
renderCurrencyMarkup()
rerenderCurrencyWithGEO()

/**  ------------ METHODS DECLARATION FOR LANGUAGES ------------  */

function handleLangClick(event) {
  if (event.target.closest('[data-current-lang]')) {
    event.stopPropagation()
    toggleLangDropdown()
  }
}

function toggleLangDropdown() {
  closeCurrencyDropdown()

  const isOpened = isLangDropdownOpened()

  if (isOpened) {
    closeLangDropdown()
  } else {
    openLangDropdown()
  }
}

function openLangDropdown() {
  closeCurrencyDropdown()

  if (langDropdownWrapper) langDropdownWrapper.classList.add('opened')
  if (langDropdownList) langDropdownList.classList.add('opened')
}

function closeLangDropdown() {
  if (langDropdownWrapper) langDropdownWrapper.classList.remove('opened')
  if (langDropdownList) langDropdownList.classList.remove('opened')
}

function isLangDropdownOpened() {
  return langDropdownWrapper?.classList.contains('opened') || false
}

function renderLangsListMarkup() {
  const langsMarkup = availablelangs.reduce((acc, lang) => {
    const langLink = lang?.value === 'en' ? '' : `${lang?.value}/`

    return (acc += `<li class="header__lang-item">
                      <a
                        class="header__lang-link body_s"
                        href="/${langLink}${currentPage}${location?.search ?? ''}${
      location.hash || ''
    }"
                        data-lang-btn-dropdown="${lang?.value}"
                        >      
                        <span>${lang?.value}</span>(${lang?.name})
                      </a>
                  </li>`)
  }, '')

  if (langsListEl) {
    langsListEl.innerHTML = langsMarkup
  }
}

function initLanguageButtons() {
  const allLangBtns = document.querySelectorAll('[data-lang-btn-dropdown]')

  allLangBtns?.forEach(el => {
    const attr = el.getAttribute('data-lang-btn-dropdown')

    el.addEventListener('click', () => {
      localStorage.setItem('lang', attr)
      setCookie('lang', attr, 30)
    })
  })
}

/**  ------------ METHODS DECLARATION FOR CURRENCY ------------  */

function handleCurrencyClick(event) {
  if (event.target.closest('[data-current-currency]')) {
    event.stopPropagation()
    toggleCurrencyDropdown()
  }
}

function toggleCurrencyDropdown() {
  closeLangDropdown()

  const isOpened = isCurrencyDropdownOpened()

  if (isOpened) {
    closeCurrencyDropdown()
  } else {
    openCurrencyDropdown()
  }
}

function openCurrencyDropdown() {
  closeLangDropdown()

  if (currencyDropdownWrapper) currencyDropdownWrapper.classList.add('opened')
  if (currencyDropdownList) currencyDropdownList.classList.add('opened')
}

function closeCurrencyDropdown() {
  if (currencyDropdownWrapper) currencyDropdownWrapper.classList.remove('opened')
  if (currencyDropdownList) currencyDropdownList.classList.remove('opened')
}

function isCurrencyDropdownOpened() {
  return currencyDropdownWrapper?.classList.contains('opened') || false
}

function renderCurrencyMarkup(bannedCountry) {
  const allCurrencies = currencyStore.getAllCurrencies()
  const displayCurrencies = { ...allCurrencies }

  if (!bannedCountry) {
    delete displayCurrencies.rub
  }

  let currencyMarkup = ''

  for (const currencyObj in displayCurrencies) {
    const data = displayCurrencies[currencyObj]

    currencyMarkup += `<li class="header__currency-item">
        <button data-cur-btn="${data.currency_type}" >
          <span class="body_s">${data.symbol + ' ' + data.currency_type.toUpperCase()}</span>
        </button>
      </li>`
  }

  if (currencyListEl) {
    currencyListEl.innerHTML = ''
    currencyListEl.insertAdjacentHTML('beforeend', currencyMarkup)
  }

  initCurrencyButtons()
}

function initCurrencyButtons() {
  const currencyBtns = document.querySelectorAll('[data-cur-btn]')
  currencyBtns?.forEach(btn => {
    btn.removeEventListener('click', onCurrencyChange)
    btn.addEventListener('click', onCurrencyChange)
  })
}

function onCurrencyChange(event) {
  const curr = event.currentTarget?.getAttribute('data-cur-btn')
  currencyStore.changeCurrency(curr)
  closeCurrencyDropdown()
}

async function rerenderCurrencyWithGEO() {
  const locationData = await getLocationsData()

  /* If it`s 3.14-dars country - calls render currency list function again with rub option */
  if (locationData?.clients_country_id === '182') {
    renderCurrencyMarkup(true)

    if (!getCookie('selected_currency')) {
      currencyStore.changeCurrency('rub')
    }
  }
}

export async function getLocationsData() {
  return await fetchUrl(`${process.env.BASE_URL}/v1/api/service/geo/`)
}

/**  ------------ GLOBAL DROPDOWN CLOSING HANDLER ------------  */

function handleDropdownClosing(event) {
  const isClickInsideLang = langParent?.contains(event.target) || false

  const isClickInsideCurrency = currencyParent?.contains(event.target) || false

  const isLangOpened = isLangDropdownOpened()
  const isCurrencyOpened = isCurrencyDropdownOpened()

  if (!isClickInsideLang && isLangOpened) {
    closeLangDropdown()
  }

  if (!isClickInsideCurrency && isCurrencyOpened) {
    closeCurrencyDropdown()
  }
}

/**  ------------ PRICE CONVERSION ------------  */

function convertPrices() {
  const currencyData = currencyStore.getSelectedCurr()

  PRICES_TO_BE_CONVERTED.forEach(([selector, euroPrice]) => {
    const element = document.querySelector(selector)

    if (element) {
      const priceText = element.textContent || element.innerText
      const currPrice = priceText.match(PRICE_REG_EXP)?.[0]

      if (currPrice) {
        const newPrice = (euroPrice * currencyData.currency).toFixed(2)
        element.innerHTML = priceText.replace(currPrice, `${currencyData.symbol}${newPrice}`)
      }
    }
  })
}
